import Vue from 'vue'
import localStorageService from "./storage/localStorageService.js";

// 本地存储
Vue.use(localStorageService)

